module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Ton4.0260101c.jpg";